import { Listing } from '@smg-real-estate/hg-rets-schema';

import { CustomPOIRequestStatus } from '@/helpers/PointOfInterests/types';

export interface LocationSurroundingInfo {
  name: string;
  time: number;
}

export type SurroundingInfoResponse = [
  TravelTimePOIKey & PublicTransportSurroundingInfo,
  LocationSurroundingInfo,
];

export enum PublicTransportSurroundingInfo {
  STATION = 'station',
  BUS_STOP = 'bus_stop',
  TRAM_STOP = 'tram_stop',
  PLATFORM = 'platform',
  BUS_STATION = 'bus_station',
  TRAIN_STATION = 'train_station',
  TRAIN_STOP = 'train_stop',
  HALT = 'halt',
}

export enum TravelTimePOIKey {
  SUPERMARKET = 'supermarket',
  PHARMACY = 'pharmacy',
  STATION = 'station',
  SCHOOL = 'school',
  TRAIN_STATIONS = 'train stations',
  // KK-1992: Persona-specific POI types
  PARK = 'park',
  PLAYGROUND = 'playground',
  KINDERGARTEN = 'kindergarten',
  SPORTS_CENTRE = 'sports_centre',
  CAFE = 'cafe',
  COWORKING = 'coworking',
  UNIVERSITY = 'university',
  LIBRARY = 'library',
  FAST_FOOD = 'fast_food',
}
export enum TravelTimeTransportationType {
  WALKING = 'walking',
  PUBLIC_TRANSPORT = 'public_transport',
}

export type TravelTimeData = {
  key: TravelTimePOIKey;
  time: number;
  name: string;
  transportation?: TravelTimeTransportationType;
}[];

export interface TravelTimeDataCollection {
  [key: string]: TravelTimeData;
}

export interface CustomPOI {
  id: string;
  transportationType: TravelTimeTransportationType;
  name: string;
  address: string;
  lat: number;
  lng: number;
}

export interface TravelTimeState {
  data: TravelTimeDataCollection | null;
  customPOIData: TravelTimeDataCollection;
  customPOI: CustomPOI | null;
  hasDefaultPOI: Listing[];
  hasUserPOI: boolean;
  loading: boolean;
  showCustomPoiModal: boolean;
  showCustomPoiSignInModal: boolean;
  requestStatus: CustomPOIRequestStatus;
}

export interface CustomPOITravelTimeData {
  travelTime: number;
  name: string;
  type: TravelTimePOIKey;
  transportation: TravelTimeTransportationType;
}

export const ALLOWED_TRAVEL_TIME_POIS = [
  TravelTimePOIKey.SUPERMARKET,
  TravelTimePOIKey.PHARMACY,
  TravelTimePOIKey.STATION,
  TravelTimePOIKey.SCHOOL,
];
export const ALLOWED_PUBLIC_TRANSPORT = [
  PublicTransportSurroundingInfo.STATION,
  PublicTransportSurroundingInfo.BUS_STOP,
  PublicTransportSurroundingInfo.TRAM_STOP,
  PublicTransportSurroundingInfo.PLATFORM,
  PublicTransportSurroundingInfo.BUS_STATION,
  PublicTransportSurroundingInfo.TRAIN_STATION,
  PublicTransportSurroundingInfo.TRAIN_STOP,
  PublicTransportSurroundingInfo.HALT,
];
